<ion-item lines="none" (click)="onClick.emit(user)" class="ion-margin-vertical">
  <div class="search-result name">
    {{ userToString(user) }}
  </div>
  <div class="search-result email">{{ user.email }}</div>
</ion-item>
